import React from "react";
import { Checkbox } from "./ui/checkbox";
import { PERM_AREAS, ADMIN_AREA_SECTIONS } from "../config/permessi";

// Editor riutilizzabile aree/categorie. value = { section: bool }, onChange(next)
// defaults = [section]: sezioni "di base" (ereditate). Spuntate di default, ma sbloccabili:
//  - togliere la spunta a una base = BLOCCO esplicito (salva false)
//  - mettere la spunta a una non-base = EXTRA (salva true)
// Salviamo solo le differenze rispetto al default.
export function PermessiEditor({ value, onChange, testidPrefix = "perm", defaults = [] }) {
  const perms = value || {};
  const defaultSet = new Set(defaults);
  const dft = (sec) => defaultSet.has(sec);
  const isOn = (sec) => (Object.prototype.hasOwnProperty.call(perms, sec) ? !!perms[sec] : dft(sec));
  const setPerm = (sec, val) => {
    const np = { ...perms };
    if (val === dft(sec)) delete np[sec]; // torna al default -> non memorizzare
    else np[sec] = val;
    onChange(np);
  };
  const toggleArea = (area, val) => {
    const np = { ...perms };
    area.items.forEach((it) => {
      if (val === dft(it.section)) delete np[it.section];
      else np[it.section] = val;
    });
    onChange(np);
  };
  return (
    <div className="space-y-2">
      {defaultSet.size > 0 && (
        <div className="flex items-center gap-4 text-[11px] text-muted-foreground px-1 flex-wrap" data-testid={`${testidPrefix}-legend`}>
          <span className="flex items-center gap-1.5"><span className="inline-block w-3 h-3 rounded-sm bg-slate-300 border border-slate-400" /> Base (dal ruolo/account)</span>
          <span className="flex items-center gap-1.5"><span className="inline-block w-3 h-3 rounded-sm bg-primary border border-primary" /> Extra abilitato</span>
          <span className="flex items-center gap-1.5"><span className="inline-block w-3 h-3 rounded-sm bg-white border border-red-400" /> Base bloccata</span>
        </div>
      )}
      {PERM_AREAS.map((area) => {
        const allOn = area.items.every((it) => isOn(it.section));
        const isAdmin = area.key === "amministrazione";
        return (
          <div key={area.key} className={`rounded-lg border p-3 ${isAdmin ? "border-amber-300 bg-amber-50/40" : ""}`} data-testid={`${testidPrefix}-area-${area.key}`}>
            <label className="flex items-center gap-2 text-sm font-bold cursor-pointer">
              <Checkbox checked={allOn} onCheckedChange={(c) => toggleArea(area, !!c)} data-testid={`${testidPrefix}-area-toggle-${area.key}`} /> {area.area}
            </label>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 mt-2 pl-6">
              {area.items.map((it) => {
                const on = isOn(it.section);
                const isBase = dft(it.section);
                const blocked = isBase && !on;
                return (
                  <label key={it.section} className={`flex items-center gap-2 text-xs cursor-pointer ${blocked ? "text-red-500" : isBase ? "text-muted-foreground" : ""}`} data-testid={`${testidPrefix}-cat-${it.section}`}>
                    <Checkbox checked={on} onCheckedChange={(c) => setPerm(it.section, !!c)} /> {it.label}
                    {isBase && on && <span className="text-[9px] font-semibold uppercase tracking-wide rounded px-1 py-0.5 bg-slate-200 text-slate-600" data-testid={`${testidPrefix}-base-badge-${it.section}`}>base</span>}
                    {blocked && <span className="text-[9px] font-semibold uppercase tracking-wide rounded px-1 py-0.5 bg-red-100 text-red-600 border border-red-300" data-testid={`${testidPrefix}-blocked-badge-${it.section}`}>bloccata</span>}
                  </label>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export const grantsAreSensitive = (perms) =>
  ADMIN_AREA_SECTIONS.some((s) => !!(perms || {})[s]);
